import { useMutation } from 'react-query';

import { revokeMfaWithPin } from '../../lib/api';

export function useMutateRevokeMfa() {
  return useMutation(revokeMfaWithPin);
}
